function initBrandHeader() {
  const brandHeader = document.querySelector('.ubh');
  if (!brandHeader) return;

  const petCards = brandHeader.querySelectorAll('.ubh__pet-card');
  const catPills = brandHeader.querySelectorAll('.ubh__cat-pill');

  const PATH_REWRITES = {
    '/collections/acana': '/collections/brand-acana',
    '/collections/orijen': '/collections/brand-orijen',
    '/collections/royal-canin': '/collections/brand-royal-canin',
    '/collections/purina': '/collections/brand-purina',
    '/collections/go-solutions': '/collections/brand-go',
    '/collections/brand-go-solutions': '/collections/brand-go',
    '/collections/now-fresh': '/collections/brand-now-fresh',
    '/collections/stella-chewys': '/collections/brand-stella-chewys'
  };

  function rewritePath(path) {
    const decoded = decodeURIComponent(path);
    for (const [legacy, active] of Object.entries(PATH_REWRITES)) {
      if (decoded === legacy) {
        return active;
      }
      if (decoded.startsWith(legacy + '/')) {
        return active + decoded.slice(legacy.length);
      }
    }
    return decoded;
  }

  // Rewrite address bar on load if it's a legacy URL
  const currentPath = window.location.pathname;
  const rewrittenPath = rewritePath(currentPath);
  if (rewrittenPath !== decodeURIComponent(currentPath)) {
    const searchParams = window.location.search;
    history.replaceState({ searchParams: new URLSearchParams(searchParams).toString() }, '', `${rewrittenPath}${searchParams}`);
  }

  // Helper to get active tags from the current pathname, decoded to avoid URL-encoding discrepancies
  function getActiveTags() {
    const decodedPath = rewritePath(window.location.pathname);
    const pathParts = decodedPath.split('/');
    const lastPart = pathParts[pathParts.length - 1];
    if (lastPart && (lastPart.includes(':') || lastPart.includes('+'))) {
      return lastPart.split('+');
    }
    return [];
  }

  // Helper to get the base collection path (without the tags)
  function getBaseCollectionPath() {
    const decodedPath = rewritePath(window.location.pathname);
    const pathParts = decodedPath.split('/');
    const lastPart = pathParts[pathParts.length - 1];
    if (lastPart && (lastPart.includes(':') || lastPart.includes('+'))) {
      return pathParts.slice(0, pathParts.length - 1).join('/');
    }
    return decodedPath;
  }

  // Helper to construct URLs for specific tag selections
  function buildUrlForTags(basePath, tags) {
    const sortedTags = [...tags].sort();
    const newPath = sortedTags.length > 0 ? `${basePath}/${sortedTags.map(encodeURIComponent).join('+')}` : basePath;
    const searchParams = new URLSearchParams(window.location.search).toString();
    return `${newPath}${searchParams ? '?' + searchParams : ''}`;
  }

  // Helper to map a category pill to its corresponding product type tag
  function getTagForPill(pill) {
    return pill.dataset.filterTypes || '';
  }

  // Apply AJAX filtering using Shopify tag routing and FacetFiltersForm.renderPage
  function applyTagFilter(tags) {
    const basePath = getBaseCollectionPath();
    const sortedTags = [...tags].sort();
    const newPath = sortedTags.length > 0 ? `${basePath}/${sortedTags.map(encodeURIComponent).join('+')}` : basePath;

    const searchParams = new URLSearchParams(window.location.search).toString();
    const newUrl = `${newPath}${searchParams ? '?' + searchParams : ''}`;

    // Update the browser history state
    history.pushState({ searchParams }, '', newUrl);

    // Call FacetFiltersForm.renderPage to trigger AJAX fetch and render
    let FacetFiltersFormClass = typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm : null;
    if (!FacetFiltersFormClass && typeof customElements !== 'undefined') {
      FacetFiltersFormClass = customElements.get('facet-filters-form');
    }

    if (FacetFiltersFormClass && typeof FacetFiltersFormClass.renderPage === 'function') {
      try {
        FacetFiltersFormClass.renderPage(searchParams, null, false);
        return true;
      } catch (err) {
        console.error('[UBH] FacetFiltersFormClass.renderPage failed:', err);
      }
    }

    console.warn('[UBH] FacetFiltersFormClass.renderPage not available');
    return false;
  }

  // Update active classes and dynamically synchronize href attributes on cards and pills
  function updateActiveStates() {
    const activeTags = getActiveTags();
    const activeTagsLower = activeTags.map(t => t.toLowerCase());

    const hasDogActive = activeTagsLower.includes('pet:dogs');
    const hasCatActive = activeTagsLower.includes('pet:cats');
    
    const basePath = getBaseCollectionPath();

    // 1. Update Pet Cards
    petCards.forEach(card => {
      const filterType = card.dataset.filterType || '';
      let targetTags = activeTags.filter(t => !t.toLowerCase().startsWith('pet:'));

      if (filterType === 'dog') {
        card.classList.toggle('active', hasDogActive);
        if (!hasDogActive) {
          targetTags.push('pet:dogs');
        }
        card.setAttribute('href', buildUrlForTags(basePath, targetTags));
      } else if (filterType === 'cat') {
        card.classList.toggle('active', hasCatActive);
        if (!hasCatActive) {
          targetTags.push('pet:cats');
        }
        card.setAttribute('href', buildUrlForTags(basePath, targetTags));
      } else {
        // All pets
        card.classList.toggle('active', !hasDogActive && !hasCatActive);
        card.setAttribute('href', buildUrlForTags(basePath, targetTags));
      }
    });

    // 2. Update Category Pills
    catPills.forEach(pill => {
      const tag = getTagForPill(pill);
      if (!tag) return;

      const tagLower = tag.toLowerCase();
      const isActive = activeTagsLower.includes(tagLower);
      pill.classList.toggle('active', isActive);

      let targetTags = [...activeTags];
      if (isActive) {
        // Toggle OFF: remove this tag
        targetTags = targetTags.filter(t => t.toLowerCase() !== tagLower);
      } else {
        // Toggle ON: replace any existing type: tag with this tag
        targetTags = targetTags.filter(t => !t.toLowerCase().startsWith('type:'));
        targetTags.push(tag);
      }
      pill.setAttribute('href', buildUrlForTags(basePath, targetTags));
    });

    // Dynamic Product Count Update
    const statValueEl = document.getElementById('UbhProductCount');
    const statLabelEl = document.getElementById('UbhProductCountLabel');
    const countTextEl = document.querySelector('.js-product-count');
    if (statValueEl && countTextEl) {
      const countText = countTextEl.innerText || '';
      const numbers = countText.match(/\d+/g);
      if (numbers && numbers.length >= 2) {
        statValueEl.innerText = `${numbers[0]} of ${numbers[1]}`;
        if (statLabelEl) statLabelEl.innerText = 'Products';
      } else if (numbers && numbers.length === 1) {
        statValueEl.innerText = numbers[0];
        if (statLabelEl) statLabelEl.innerText = 'Total Products';
      }
    }
  }

  // Handle Pet Card click
  function handlePetCardClick(e) {
    const card = e.currentTarget;
    const filterType = card.dataset.filterType; // 'dog', 'cat', or 'all'

    let tags = getActiveTags();
    const activeTagsLower = tags.map(t => t.toLowerCase());

    // Filter out existing pet: tags
    tags = tags.filter(t => !t.toLowerCase().startsWith('pet:'));

    if (filterType === 'dog') {
      if (!activeTagsLower.includes('pet:dogs')) {
        tags.push('pet:dogs');
      }
    } else if (filterType === 'cat') {
      if (!activeTagsLower.includes('pet:cats')) {
        tags.push('pet:cats');
      }
    }

    const success = applyTagFilter(tags);
    if (success) {
      e.preventDefault();
    }
  }

  // Handle Category Pill click
  function handleCatPillClick(e) {
    const pill = e.currentTarget;
    const tag = getTagForPill(pill);
    if (!tag) return; // Allow normal link behavior if tag is empty

    let tags = getActiveTags();
    const tagLower = tag.toLowerCase();
    const activeTagsLower = tags.map(t => t.toLowerCase());

    if (activeTagsLower.includes(tagLower)) {
      // Toggle off: remove tag
      tags = tags.filter(t => t.toLowerCase() !== tagLower);
    } else {
      // Toggle on: replace existing type: tags
      tags = tags.filter(t => !t.toLowerCase().startsWith('type:'));
      tags.push(tag);
    }

    const success = applyTagFilter(tags);
    if (success) {
      e.preventDefault();
    }
  }

  // Attach click handlers
  petCards.forEach(card => card.addEventListener('click', handlePetCardClick));
  catPills.forEach(pill => pill.addEventListener('click', handleCatPillClick));

  // Sync active states on back/forward navigation
  let lastPathname = window.location.pathname;
  window.addEventListener('popstate', () => {
    if (window.location.pathname !== lastPathname) {
      lastPathname = window.location.pathname;
      const searchParams = new URLSearchParams(window.location.search).toString();
      
      let FacetFiltersFormClass = typeof FacetFiltersForm !== 'undefined' ? FacetFiltersForm : null;
      if (!FacetFiltersFormClass && typeof customElements !== 'undefined') {
        FacetFiltersFormClass = customElements.get('facet-filters-form');
      }

      if (FacetFiltersFormClass && typeof FacetFiltersFormClass.renderPage === 'function') {
        FacetFiltersFormClass.renderPage(searchParams, null, false);
      }
    }
    updateActiveStates();
  });

  // Watch for AJAX page updates to re-sync active states
  const productGrid = document.getElementById('ProductGridContainer');
  if (productGrid) {
    const observer = new MutationObserver(() => {
      updateActiveStates();
    });
    observer.observe(productGrid, { childList: true, subtree: true });
  }

  // Initial sync
  updateActiveStates();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBrandHeader);
} else {
  initBrandHeader();
}
